/**
 * 权限管理工具函数
 * 用于前端角色判断和数据权限控制
 */
import store from '@/store'

/**
 * 角色类型常量
 */
export const ROLE_TYPE = {
  SUPER_ADMIN: 'super_admin',
  COUNTY: 'county',
  TOWN: 'town',
  VILLAGE: 'village'
}

/**
 * 角色层级权重（用于比较）
 */
const ROLE_LEVEL = {
  super_admin: 4,
  county: 3,
  town: 2,
  village: 1
}

/**
 * 获取当前用户信息
 */
export function getUserInfo() {
  return store.getters.userInfo || {}
}

/**
 * 获取当前用户角色类型
 */
export function getRoleType() {
  const userInfo = getUserInfo()
  return userInfo.roleType || null
}

/**
 * 获取当前用户的行政区划信息
 */
export function getUserRegion() {
  const userInfo = getUserInfo()
  return {
    countyCode: userInfo.countyCode || '',
    townCode: userInfo.townCode || '',
    villageCode: userInfo.villageCode || ''
  }
}

/**
 * 判断是否为管理员
 */
export function isAdmin() {
  return getRoleType() === ROLE_TYPE.SUPER_ADMIN
}

/**
 * 判断是否为县级及以上角色
 */
export function isCountyOrAbove() {
  const type = getRoleType()
  return type === ROLE_TYPE.SUPER_ADMIN || type === ROLE_TYPE.COUNTY
}

/**
 * 判断是否为乡镇级及以上角色
 */
export function isTownOrAbove() {
  const type = getRoleType()
  return type === ROLE_TYPE.SUPER_ADMIN || type === ROLE_TYPE.COUNTY || type === ROLE_TYPE.TOWN
}

/**
 * 判断当前用户是否有指定级别或更高权限
 * @param {string} requiredRole - 需要的角色类型
 * @returns {boolean}
 */
export function hasRoleOrAbove(requiredRole) {
  const currentType = getRoleType()
  if (!currentType || !requiredRole) return false

  const currentLevel = ROLE_LEVEL[currentType] || 0
  const requiredLevel = ROLE_LEVEL[requiredRole] || 0

  return currentLevel >= requiredLevel
}

/**
 * 判断当前用户是否为指定角色
 * @param {string|string[]} roles - 角色类型或角色类型数组
 * @returns {boolean}
 */
export function hasRole(roles) {
  const currentType = getRoleType()
  if (!currentType) return false

  if (Array.isArray(roles)) {
    return roles.includes(currentType)
  }

  return currentType === roles
}

/**
 * 获取角色显示名称
 * @param {string} roleType - 角色类型
 * @returns {string}
 */
export function getRoleTypeName(roleType) {
  const names = {
    super_admin: '系统管理员',
    county: '县级管理员',
    town: '乡镇管理员',
    village: '村级管理员'
  }
  return names[roleType] || '未知角色'
}
